import { Howl, type HowlOptions } from 'howler';
import bgm from './assets/music/background.mp3';
import btnClick from './assets/music/btn-click.mp3';
import btnHover from './assets/music/btn-hover.mp3';
import signUp from './assets/music/sign-up.mp3';

interface Config {
  onBgmPlay?: () => void;
  onBgmStop?: () => void;
}

export class AudioController {
  stop = true;
  bgmOptions: HowlOptions;
  config: Config;

  instance: {
    bgm: Howl;
    btnClick: Howl;
    btnHover: Howl;
    signUpClick: Howl;
  };

  constructor(config: Config) {
    this.config = config;
    this.bgmOptions = {
      src: bgm,
      loop: true,
      autoplay: false,
      // autoplay: !window.location.search.includes('mute=1'),
      // html5: true,
      volume: 1,
      onplay: () => {
        this.stop = false;
        config.onBgmPlay?.();
      },
    };

    this.instance = {
      bgm: new Howl(this.bgmOptions),
      btnClick: new Howl({
        src: btnClick,
        volume: 0.5,
        loop: false,
      }),
      btnHover: new Howl({
        src: btnHover,
        loop: false,
        volume: 0.8,
      }),
      signUpClick: new Howl({
        src: signUp,
        loop: false,
        volume: 0.8,
      }),
    };

    /** 切换浏览器标签，静音 */
    // document.addEventListener('visibilitychange', () => {
    //   /** 如果当前是暂停的 return，防止切换回来就自己播放了 */
    //   if (this.stop) {
    //     return;
    //   }
    //   this.instance.bgm.stop();
    //   this.instance.bgm.unload();
    //   this.instance.bgm = new Howl(this.bgmOptions);
    //   Howler.mute(true);
    //   this.stop = true;
    //   setTimeout(() => {
    //     if (document.visibilityState === 'visible') {
    //       Howler.mute(false);
    //     } else {
    //       // 关闭媒体
    //       Howler.mute(true);
    //     }
    //   }, 100);
    // });
  }

  switchBgm() {
    if (this.stop) {
      this.instance.bgm.play();
      this.stop = false;
      this.instance.bgm.mute(false);
      this.config.onBgmPlay?.();
    } else {
      this.stop = true;
      this.instance.bgm.mute(true);
      this.config.onBgmStop?.();
    }
  }

  muteBgm() {
    this.stop = true;
    this.instance.bgm.mute(true);
    this.config.onBgmStop?.();
  }
}
